import { post, get } from '../http';

export const getPayments = async () => get('Payment/me');
export const fetchUrl = async id =>
  post('Payment', {
    bookingId: id
  });

export const fetch = async id => get(`Payment/${id}`);
